export default __webpack_public_path__ + "static/media/01.c7d2be5a.jpg";